"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _DimplLogo = _interopRequireDefault(require("./icons/DimplLogo"));

require("./logotopleft.scss");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LogoTopLeft = function LogoTopLeft(_ref) {
  var className = _ref.className,
      logoClick = _ref.logoClick,
      child = _ref.child;
  return (
    /*#__PURE__*/
    // TODO : level
    (0, _jsxRuntime.jsxs)("div", {
      className: "".concat(!!className ? "".concat(className, " ") : '', "p-horizontal-center p-padding-top-6 p-padding-bottom-6"),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: 'p-logo' + (!!logoClick ? ' p-clickable' : ''),
        onClick: logoClick || false,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DimplLogo["default"], {})
      }), !!child && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "p-margin-left-5 p-border-left p-padding-left-5",
        children: child
      })]
    })
  );
};

var _default = LogoTopLeft;
exports["default"] = _default;